import { render, staticRenderFns } from "./QuizStudent.vue?vue&type=template&id=67cfdffa&"
import script from "./QuizStudent.vue?vue&type=script&lang=js&"
export * from "./QuizStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports